import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'incidentsFilter'
})
export class IncidentsFilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) { return []; }
        if (!searchText) { return items; }
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.driverName.toLowerCase().includes(searchText) || it.driverNumber === +searchText ||
                it.status.toLowerCase().includes(searchText) || it.round === searchText;
        });
    }
}
